import React from "react";
import RoundButton from "../../../Common/RoundButton";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
const KycInfoForm = ({
  handleContinue,
  disable,
  handleImageClick,
  manualKycImage,
}: any) => {
  return (
    <>
      <div style={{ marginTop: "35px", marginBottom: "30px" }}>
        {manualKycImage !== undefined ? (
          <img src={manualKycImage} />
        ) : (
          <img
            onClick={handleImageClick}
            className="pancard-img"
            src={
              "https://3.bp.blogspot.com/-Ra43UmezDWk/WLGpYtFGcpI/AAAAAAAAQFU/MgFpPseZyzcyBQ_-JK3ARdjOJrZ4aqDUgCLcB/s320/pan-card-big-size-300x190.jpg"
            }
          />
        )}
      </div>
      <Typography className="fs-14 fw-500">
        Make sure you place your <span className="fw-700">PAN card</span> inside
        the frame as shown as above
      </Typography>
      <div style={{ marginTop: "40px" }}>
        <RoundButton
          disable={disable}
          onClick={handleContinue}
          title={"Continue"}
        />
      </div>
    </>
  );
};

export default KycInfoForm;